import { featuresData } from "@/mocks/homeData";

export default function FeaturesSection() {
  return (
    <section id="features" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-12">
          <span className="text-xs font-semibold text-primary-500 uppercase tracking-wide">Why Choose Us</span>
          <h2 className="text-xl md:text-2xl font-bold text-foreground-950 mt-2 font-heading">为什么选51吃瓜？</h2>
          <p className="text-sm text-foreground-600 mt-2 max-w-lg mx-auto">
            五大核心优势，打造全网最专业的吃瓜体验
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4 md:gap-5">
          {featuresData.map((feat, i) => (
            <div
              key={i}
              className="group bg-background-50 border border-background-200/70 rounded-xl p-5 md:p-6 cursor-pointer transition-all hover:border-primary-200/50 text-center lg:text-left"
            >
              <div className="w-10 h-10 md:w-11 md:h-11 rounded-xl bg-accent-100 flex items-center justify-center mx-auto lg:mx-0 mb-4 group-hover:bg-accent-200 transition-colors">
                <i className={`${feat.icon} text-accent-600 text-lg md:text-xl`}></i>
              </div>
              <h3 className="text-sm md:text-base font-semibold text-foreground-950 mb-2 font-heading">
                {feat.title}
              </h3>
              <p className="text-xs md:text-sm text-foreground-600 leading-relaxed">
                {feat.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}